import BouncingSpinner from 'components/BouncingSpinner';
import React from 'react';

interface Props {
  text: string;
}

class LoadingOverlay extends React.Component<Props> {
  render(): React.ReactNode {
    return (
      <div
        className="pos-a bgd-white h100 w100"
        style={{ zIndex: 1000, opacity: '0.8' }}
      >
        <div className="flex-center h100">
          <div className="column items-center">
            <div className="font-size-6 mb3">{this.props.text}</div>
            <BouncingSpinner />
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingOverlay;
